<template>
		<Tile :id="pin.id" :title="pinTitle">
			<template  v-slot:content>
				<DisplayUser :hideTitle="true" v-if="pin.pinType == 'user'" :user="pin"></DisplayUser>
				<DisplayNote  v-if="pin.pinType == 'note'" :note="pin"></DisplayNote>
				<DisplayGroup :hideTitle="true" v-if="pin.pinType == 'group'" :group="pin"></DisplayGroup>
				<DisplayCollaboration :hideTitle="true" v-if="pin.pinType == 'collaboration'" :collaboration="pin"></DisplayCollaboration>
			</template>
		</Tile>
</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import Tile from "@/components/elements/Tile"
	export default {
		name: "PinnedTile", 
		props: {
			pin: { type: Object }
		},
		data: () => {
			return {

			}
		},
		components: {
			Tile,
			DisplayUser: () => import("@/components/assessment/users/DisplayUser"), 
			DisplayNote: () => import("@/components/assessment/DisplayNote"), 
			DisplayCollaboration: () => import("@/components/assessment/collaborations/DisplayCollaboration"), 
			DisplayGroup: () => import("@/components/assessment/groups/DisplayGroup")
		},
		computed: {
			...Vuex.mapState({
				users: state => state.users
			}),
			pinTitle(){
				if( this.pin.pinType == "note" ){
					var author = this.pin.author;
					var user = this.users.find( a => a.id == author	)
					return user.display_name
				}
				return this.pin.display_name || this.pin.name
			}
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>